import bannerHideReason from './bannerHideReason';
import ulpCookies from '../ulpCookies';
import Url from 'utils/url/url';

export const findMatchingExcludedUrl = (excluded, currentLocation, origin) =>
  excluded.some(exclusion => {
    const excludedUrl = new Url(exclusion, origin);
    const currentUrl = new Url(currentLocation, origin);

    // Check if the current location contains query parameters from the exclusion
    const includesParams = Object.entries(excludedUrl.query).every(entry => {
      const [key, value] = entry;
      return currentUrl.query[key] && currentUrl.query[key] === value;
    });

    // Compare the origin of the current location and exclusion if parameter is set
    const sameOrigin = (origin) ? excludedUrl.origin === currentUrl.origin : true;

    return excludedUrl.pathname === currentUrl.pathname && includesParams && sameOrigin;
  });

export const isExternalReferrer = (referrer, origin) => {
  if (referrer === '') {
    return true;
  } else {
    const referrerUrl = new URL(referrer);
    return referrerUrl.origin !== origin;
  }
};

export const isUlpBannerVisible = (state) => {
  const {
    currentRoute,
    exclusions,
    isTemporaryHidden,
    origin,
    placedOrdersCount,
    previousRoute,
    referrer,
    userPreferences,
    userHidBanner,
  } = state;

  const rulesInOrder = [
    // check for exclusions
    // Excluded Referrer is same as Excluded Entry Point, however first tracking reason is Excluded Referrer and then EEP
    () => (exclusions.excludedReferrers && findMatchingExcludedUrl(exclusions.excludedReferrers, referrer, origin)
      ? bannerHideReason.EXCLUDED_REFERRER
      : false),

    () => (exclusions.excludedActions && findMatchingExcludedUrl(exclusions.excludedActions, currentRoute)
      ? bannerHideReason.ACTION_EXCLUDED
      : false),
    // Excluded Entry Point is exclued when user enters EEP as FIRST PAGE ( eg. from Bookmarks ) without internal referrer
    () => (exclusions.excludedEntryPoints && findMatchingExcludedUrl(exclusions.excludedEntryPoints, currentRoute)
      && previousRoute === ''
      && isExternalReferrer(referrer, origin)
      ? bannerHideReason.EXCLUDED_ENTRY_POINT
      : false),

    // check user cookies in preferences
    () => (ulpCookies.EXCLUDED_ENTRY_POINT.name in userPreferences
      ? bannerHideReason.EXCLUDED_ENTRY_POINT
      : false),

    () => (ulpCookies.USER_HID_BANNER.name in userPreferences || userHidBanner
      ? bannerHideReason.USER_HID_BANNER
      : false),

    () => (ulpCookies.ORDER_WAS_PLACED.name in userPreferences
      ? bannerHideReason.OWP_COOKIE_EXISTS
      : false),

    // check other rules based on store
    () => (placedOrdersCount > 0
      ? bannerHideReason.ORDERS_WERE_PLACED
      : false),

    () => (isTemporaryHidden
      ? bannerHideReason.TEMPORARY_HIDDEN
      : false),
  ];

  for (const rule of rulesInOrder) {
    const evaluatedRule = rule();
    if (evaluatedRule) {
      return {
        isVisible: false,
        reason: evaluatedRule,
      };
    }
  }

  return {
    isVisible: true,
    reason: bannerHideReason.NONE,
  };
};
